<template>
  <div class="mobile-menu">
    <v-app-bar
      color="primary"
      class="d-block d-sm-block d-md-none d-lg-none mobile-bar"
      dense
      fixed
      height="60"
      dark
    >
      <v-img
        :width="135"
        v-if="!miniSearch"
        :max-width="135"
        :src="logo2"
      ></v-img>

      <v-spacer v-if="!miniSearch"></v-spacer>
      <transition name="fade">
        <v-text-field
          hide-details
          id="text-search"
          v-model="setSearchTerm"
          placeholder="Buscar"
          class="ml-5 mr-5"
          v-if="miniSearch"
        ></v-text-field>
      </transition>

      <v-btn v-if="showSearchMobile" fab icon dark color="primary">
        <v-icon dark class="white--text" @click="miniSearch = !miniSearch">
          {{ miniSearch ? "fas fa-times" : "fas fa-search" }}</v-icon
        >
      </v-btn>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      class="d-block d-sm-block d-md-none d-lg-none"
      v-model="drawer"
      fixed
      temporary
    >
      <div class="logo">
        <v-img :width="135" :max-width="135" :src="logo1"></v-img>
      </div>

      <v-list dense nav>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item
            class="mt-5 mb-5"
            v-for="(item, i) in routes"
            :to="item.path"
            :key="i"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider style="margin-top: 40%"></v-divider>

          <v-list-item @click="$emit('logOut')">
            <v-list-item-icon>
              <v-icon>fas fa-sign-out</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list-item-group>
      </v-list>
      <div class="by">
        <small>Dilo Delivery.</small>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "mobile-menu",

  data() {
    return {
      miniSearch: false,
      drawer: false,
      selectedItem: "",
      logo2: require("@/assets/logo2.svg"),
      logo1: require("@/assets/logo1.svg"),
      routes: [
        {
          text: "Nuevo mandado",
          path: "/menu",
          icon: "far fa-plus",
        },
        {
          text: "Histórico de órdenes",
          path: "/tracking/1",
          icon: "far fa-list-ol",
        },

        {
          text: "Métodos de pago",
          path: "/payment-methods",
          icon: "fa-credit-card",
        },
        {
          text: "Puntos permitidos",
          path: "/points",
          icon: "fas fa-map-marked-alt",
        },
        {
          text: "Configuraciones",
          path: "/settings",
          icon: "far fa-cog",
        },
      ],
    };
  },
  computed: {
    ...mapState(["search", "searchTerm", "searchLabel", "showSearchMobile"]),
    setSearchTerm: {
      get() {
        return this.searchTerm;
      },
      set(e) {
        this.updateSearchTerm(e);
      },
    },
  },

  watch: {
    miniSearch(e) {
      // if (e) {
      //   document.getElementById("text-search").autofocus;
      // }
    },
  },

  methods: {
    ...mapActions(["updateSearchTerm"]),
  },
};
</script>

<style>
.logo {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10%;
}

.by {
  /* position: absolute; */
  /* top: 95vh; */
  margin-top: 15%;
  color: rgb(112, 112, 112);
  display: flex;
  justify-content: center;
  width: 100%;
}
.mobile-menu {
  top: 0;
  position: absolute;
  width: 100%;
}

.mobile-bar {
  /* top: 0; */
  position: fixed !important;
  /* top: 0; */
  /* bottom: 0; */
}
</style>